import {NUMERIC_DECIMAL_SEPARATOR} from '@fo/shared-types/constants';

/**
 * Validading and then submitting though a callback
 */
export default (name: string, maxValue = 100, callbackFn: (name: string, value?: string) => void) =>
  (event: React.ChangeEvent<HTMLInputElement>): void => {
    const inputValue = event.target.value;
    const lastInputChar = inputValue.slice(-1);
    const isLastCharDecimalSeparator = lastInputChar === NUMERIC_DECIMAL_SEPARATOR;
    // Avoids the use of more than one decimal separator
    // Unfortunatelly RegExp won't work here because one of the existent decimal separators is a . (dot)
    // meaning "All characters". Escaping won't work because the other one is a comma and it's breaking it
    const isMoreThanOneDecimalSeparator =
      (inputValue.split('').filter((char) => char === NUMERIC_DECIMAL_SEPARATOR)?.length || 0) > 1;
    // for numerical comparisons
    const valueAsFloat = parseFloat(inputValue);
    // garantees that the localised number value is a mathematical number (with . as a decimal separator)
    const unLocalisedValue = inputValue.split(NUMERIC_DECIMAL_SEPARATOR).join('.').toString();

    // makes sure an empty value gets updated in Formik's state
    if (inputValue === '' || inputValue === NUMERIC_DECIMAL_SEPARATOR) {
      callbackFn(name, undefined);
      return;
    }

    if (isMoreThanOneDecimalSeparator) {
      return;
    }

    // Limits the percentage to the maxValue
    if (
      valueAsFloat > maxValue ||
      // limits to 99.99 (2 characters after the decimal separator)
      // otherwise it could go up to 99.9999999
      // that javascript would eventually round up to 100
      unLocalisedValue.split('.')[1]?.length > 2 ||
      // prevents from user typing 'maxValue.'
      (valueAsFloat === maxValue && isLastCharDecimalSeparator)
    ) {
      return;
    }

    // ignore if it's a character that's not a number
    if (Number.isNaN(parseInt(lastInputChar, 10)) && !isLastCharDecimalSeparator) {
      return;
    }

    // pass up the value
    callbackFn(name, unLocalisedValue);
  };
